import { Instance, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { AdminSponsorService } from '@services/adminSponsorService';
import { LanguageService } from '@services/languageService';
import { initTable } from '@utils/collectionSetup';
import { AdminController } from './adminController';

export class AdminSponsorsIndexController extends AdminController {
    static readonly inject = [
        'instances',
        'adminSponsorService',
        'languageService',
    ] as const;

    private table!: Table;

    constructor(
        instances: Instance,
        private adminSponsorService: AdminSponsorService,
        private languageService: LanguageService,
    ) {
        super(instances);
    }

    protected override _initToolbarButtons(): void {
        this.helper.iconButton('.btn-admin-index', this.dom, () => {
            this.state.goBack('admin.index');
        });

        this.helper.fabButton('.btn-sponsors-new', this.dom, () => {
            this.adminSponsorService.newDialogByAdmin().then(() => {
                this._drawContent();
            });
        });
    }

    protected override _initTable(): void {
        this.table = initTable(
            this.table,
            this.dom,
            'table',
            this.adminSponsorService,
            {
                entityKey: 'sponsors',
                fetchData: (params) =>
                    this.adminSponsorService.getAll(params),
                extraParams: (params) => {
                    params.set('query', this.query);
                },
            },
            [
                {
                    style: () => {
                        return [
                            'edit',
                            this.languageService.translate('buttons.edit'),
                        ];
                    },
                    click: (sponsor) => {
                        this.adminSponsorService
                            .editDialog(sponsor, '/admin/')
                            .then(() => {
                                this._drawContent();
                            });
                    },
                },
            ],
        )!;
    }
}

export const adminSponsorsIndexController = app.controller(
    'adminSponsorsIndexController',
    AdminSponsorsIndexController,
);
